/**
 * @generated SignedSource<<b85b862118ab47be5d9a139fc8ca0c61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskConnections_topics$data = ReadonlyArray<{
  readonly id: string;
  readonly isPrivate: boolean;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineEditMainOrgTopicListItemSelector_topics">;
  readonly " $fragmentType": "TaskConnections_topics";
}>;
export type TaskConnections_topics$key = ReadonlyArray<{
  readonly " $data"?: TaskConnections_topics$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskConnections_topics">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TaskConnections_topics",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivate",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoutineEditMainOrgTopicListItemSelector_topics"
    }
  ],
  "type": "OrgTopic",
  "abstractKey": null
};

(node as any).hash = "bacb8f6bbf30a3bcc2741cd3964b7475";

export default node;
